/** ``1.\\n**Title**`` → ``1. **Title**`` so GFM keeps number + body on one item. */
const BROKEN_ORDERED_LIST_MARKER = /^(\d{1,3})\.[ \t]*\n+(?=\*\*)/gm;

/** Normalize CRs and join broken ordered markers before Streamdown. */
export const prepareVoiceMarkdown = (text: string): string => {
  const normalized = text.replace(/\r\n?/g, '\n');
  if (!/\d\.[ \t]*\n/.test(normalized)) return normalized;
  return normalized.replace(BROKEN_ORDERED_LIST_MARKER, '$1. ');
};
